import { useMemo } from 'react';
import { useGlobalState } from 'src/stateProviders/GlobalStateProvider';

const useIsDesignPackageEnabled = () => {
	const { company } = useGlobalState() ?? {};
	return useMemo(() => Boolean(company?.designPackageEnabled), [company]);
};

export default useIsDesignPackageEnabled;
